import styled from 'styled-components';

export const StyledIconType = styled.div<{ color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 9px;
  background-color: ${(props) => props.color};
`;
